import {is_function} from '../../../../Helpers/js/simple.functions';
import {CheckboxGroup} from '../CheckboxGroup';

export class MultiChoiceQuestion {
    constructor(questionNode, onChange) {
        this.domNode = questionNode;
        this.onChangeOriginal = onChange;

        this.maxAnswers = parseInt(questionNode.querySelector('[role="group"]').getAttribute('data-max'));

        var globalNoAnswerId = parseInt(questionNode.querySelector('[role="group"]').getAttribute('data-noanswer-id'));
        var groups = Array.from(questionNode.querySelectorAll('[option-group="1"]'));
        this.checkboxGroups = groups.map(group => {
            var checkboxes = Array.from(group.querySelectorAll('[role="checkbox"]'));
            var noAnswerId = globalNoAnswerId || parseInt(group.getAttribute('data-noanswer-id'));

            return new CheckboxGroup(checkboxes, this.answersChanged.bind(this), noAnswerId);
        });

        this.handleMaxAnswers();
    }

    answersChanged() {
        this.handleMaxAnswers();
        if (is_function(this.onChangeOriginal)) {
            this.onChangeOriginal();
        }

    }

    handleMaxAnswers() {
        if (!this.maxAnswers) {
            return;
        }

        var numAnswers = this.countAnswers();
        if (numAnswers >= this.maxAnswers) {
            this.checkboxGroups.map(group => group.disableAllUncheckedCheckboxes());
        } else {
            this.checkboxGroups.map(group => group.enableAllCheckboxes());
        }
    }

    countAnswers() {
        return this.checkboxGroups.reduce((count, group) => count + group.countAnswers(), 0);
    }
}